import { MenuItem } from 'primeng/api';
import { DateRangeValue } from '@hub-components';
import { BenchmarkPeriodOption } from 'app/hub-components/components/benchmarks/benchmarks.component';

export const DEFAULT_TITLE_FONT_SIZE = 18;

export const DEFAULT_TITLE_ALIGNMENT = 'center';

export const DEFAULT_LEGEND_FONT_SIZE = 14;

export const DEFAULT_AXIS_FONT_SIZE = 12;

export const DEFAULT_AXIS = 'left';

export const DEFAULT_TABLE_TEXT_FONT_SIZE = 14;

export const DEFAULT_DATA_LABEL_FONT_SIZE = 14;

export const DEFAULT_KPI_METRIC = { align: 'center', size: 56 };

export const DEFAULT_DIMENSION_VALUE = { align: 'center', size: 56 };

export const DEFAULT_METRIC_LABEL = { enabled: true, align: 'center', size: 22 };

export const DEFAULT_DIMENSION_LABEL = { enabled: true, align: 'center', size: 22 };

export const DEFAULT_RESULTS_PER_PAGE = 10;

export const RESULTS_PER_PAGE_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 50, 100];

export const DEFAULT_DIMENSION_VALUE_RESULTS = 1;

export const DEFAULT_FOOTER_TOGGLE = { datasetInfo: false, dateRange: false, comparisonDateRange: false };

export const DEFAULT_INCLUDE_DIMENSIONS_TOGGLE = true;

export const DEFAULT_SHOW_COLUMN_GRAND_TOTALS = false;

export const DEFAULT_SHOW_ROW_GRAND_TOTALS = false;

export const DEFAULT_SHOW_COLUMN_ALL_PAGES_TOTALS = false;

export const DEFAULT_BORDER_COLOR = '#DCDCDC';

export const DEFAULT_COLORPICKER_COLOR = 'bcc3cd';

export const DEFAULT_DATE_RANGE = {
  enabled: false,
  value: <DateRangeValue> {
    type: 'dynamic' as 'dynamic',
    dynamic: { title: 'Last 7 Days', name: 'last', num: 7, unit: 'day' as 'day' },
  },
};

export const DEFAULT_MAP_TYPE = { value: 'custom/world-robinson', name: 'World' };

export const DEFAULT_SHOW_DATA_AS = 'percentages';

export const DEFAULT_COMPARE_TO: BenchmarkPeriodOption = { name: 'None', value: 'none' };

export const ALL_COMPARISONS: BenchmarkPeriodOption[] = [
  { name: 'None', value: 'none' },
  { name: 'Previous Period', value: 'previous_period' },
  { name: 'Previous Year(s)', value: 'previous_year' },
  { name: 'Custom Period', value: 'custom' },
];

export const BENCHMARK_DISPLAY_OPTIONS: { name: string, value: string }[] = [
  { name: 'Percentages', value: 'percentages' },
  { name: 'Values', value: 'values' },
  { name: 'Both', value: 'both' },
];

export const DEFAULT_COMPARE_TO_DISPLAY = {
  separateColumn: false,
  benchmarksAs: BENCHMARK_DISPLAY_OPTIONS[0],
  groupedHeader: false,
};

export const DEFAULT_COMPARE_TO_VALUE = false;

export const UPLOAD_IMAGE = 'uploadImage';

export const INSERT_URL = 'insertUrl';

export const USE_ATTRIBUTE = 'useAttribute';

export const DEFAULT_IMAGE_SOURCE = UPLOAD_IMAGE;

export const LINK_URL_PATTERN = /^(https?:\/\/|\/\/)?([-a-zA-Z0-9@:%._+~#=]+\.)+[a-zA-Z0-9()]+?(\/[-a-zA-Z0-9()@:%_+.~#?&//=]*)?$/i;

export const DEFAULT_WYSIWYG_OPTIONS = {
  type: 'freetext',
  options: {
    globalDateRange: false,
  },
};

export const DEFAULT_WYSIWYG_PLACEMENT = { position: 'top' };

export const DEFAULT_WYSIWYG_TOOLBAR = true;

export const TAB_MENU_ITEMS: MenuItem[] = [
  {
    id: 'all',
    label: 'All dashboards',
    routerLink: '/all-dashboards',
  },
  {
    id: 'favorites-list',
    label: 'Favorites',
    routerLink: '/favorites-list',
  },
  {
    id: 'my',
    label: 'My dashboards',
    routerLink: '/my-dashboards',
  },
  {
    id: 'scheduled',
    label: 'Scheduled dashboards',
    routerLink: '/scheduled-dashboards',
  },
  {
    id: 'shared',
    label: 'Shared dashboards',
    routerLink: '/shared-dashboards',
  },
  {
    id: 'sharedWithMe',
    label: 'Shared with me',
    routerLink: '/shared-with-me',
  },
  {
    id: 'templates',
    label: 'Dashboard templates',
    routerLink: '/dashboard-templates',
  },
  {
    id: 'audits',
    label: 'Audits',
    routerLink: '/dashboard-audit-list',
  },
];
